import type { TableColumnsType } from 'antd';
import type { DistributionListType } from './DistributionLists.types.ts';
import * as Yup from 'yup';
import i18n from '../../utils/i18n.ts';
import { HomeOutlined } from '@ant-design/icons';

export const DISTRIBUTION_LIST_FORM = 'DistributionListForm';

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    href: '/admin',
    title: i18n.t('pages.admin.title'),
  },
  {
    title: i18n.t('pages.admin.module.distribution-lists'),
  },
];

export const DISTRIBUTION_LISTS_COLUMNS: TableColumnsType<DistributionListType> = [
  {
    title: i18n.t('pages.distribution-lists.name'),
    dataIndex: 'name',
    width: 300,
  },
  {
    title: i18n.t('pages.distribution-lists.recipients'),
    dataIndex: 'recipients',
    render: (values: string[]) => values?.join(', ') || 'No recipients',
  },
];

export const DISTRIBUTION_LISTS_FORM_SCHEMA = Yup.object().shape({
  name: Yup.string().required(i18n.t('error.validation.required-name')),
  recipients: Yup.string()
    .required(i18n.t('error.validation.required-email'))
    .test('multiple-emails', i18n.t('error.validation.valid-email'), (value) => {
      if (!value) return false;
      const emails = value.split(',').map((email) => email.trim());
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      return emails.every((email) => emailRegex.test(email));
    }),
});

export const DISTRIBUTION_LISTS_INITIAL_FORM_VALUES = {
  id: null,
  name: '',
  recipients: '',
};
